/* RESPONSIBLE TEAM: team-pricing-and-packaging */
import { inject as service } from '@ember/service';
import BillingSettingsRoute from 'embercom/routes/apps/app/settings/base/billing-settings-route';
import { ReactRoute } from 'embercom/lib/react-route';
import type IntlService from 'embercom/services/intl';

class InvoicesParentRoute extends BillingSettingsRoute {
  @service declare appService: $TSFixMe;
  @service declare intl: IntlService;

  analytics = {
    place: 'invoices',
  };

  reactEnabled() {
    return this.appService.app.canUseBillingInvoiceRedesign;
  }

  get titleToken() {
    return this.intl.t(`billing.invoices.index.header`);
  }
}

export default ReactRoute(InvoicesParentRoute);
